import { render } from "./chargechart.vue?vue&type=template&id=4f0a9621"
import script from "./chargechart.vue?vue&type=script&lang=js"
export * from "./chargechart.vue?vue&type=script&lang=js"

import "./chargechart.vue?vue&type=style&index=0&id=4f0a9621&lang=less"
script.render = render

export default script